import React, {Component} from 'react';
import './ImagePopup.css';
import Popup from "../../components/popup/Popup";

export default class ImagePopup extends Component{
  render(){
    return(<Popup {...this.props} show={this.props.show} className="g-image-popup">
					<img src={this.props.src}/>
		</Popup>
    )
  }
}


// WEBPACK FOOTER //
// ./src/popups/imagePopup/ImagePopup.jsx